import * as React from "react";
import { FileBadge } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
export default function LegalBasis() {
  return <section id="legal-basis" className="bg-background py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
          {}
          <div className="md:col-start-7 md:col-span-5 lg:col-start-7 lg:col-span-5">
            <Card className="rounded-[2px] border-secondary shadow-none bg-card">
              <CardHeader className="pb-4">
                <CardTitle className="flex items-center gap-3 text-xl font-semibold tracking-tight">
                  <FileBadge className="size-6 text-foreground" strokeWidth={2} strokeLinecap="square" strokeLinejoin="miter" />
                  Legal Basis
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-4 font-sans text-base text-muted-foreground leading-relaxed">
                  <p>
                    The processing of personal contact information is strictly governed by the EU General Data Protection Regulation (GDPR) and Spanish data protection law to ensure your privacy and security.
                  </p>
                  <p>
                    In accordance with <span className="font-mono text-chart-2 bg-chart-2/10 px-1.5 py-0.5 rounded-[2px] text-sm font-medium">Article 6(1)(a) GDPR</span>, we process personal contact information based on your explicit consent and, where applicable, legitimate interest. You maintain the right to withdraw this consent at any time.
                  </p>
                  <p>
                    Furthermore, technical and organizational security measures are implemented as required by <span className="font-mono text-chart-2 bg-chart-2/10 px-1.5 py-0.5 rounded-[2px] text-sm font-medium">Recital 32</span> and Spanish law to ensure a level of security appropriate to the risk, protecting the integrity of your personal information.
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}